import script from "./base-avatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./base-avatar.vue?vue&type=script&setup=true&lang=ts"

import "./base-avatar.vue?vue&type=style&index=0&id=1908dd5e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1908dd5e"]])

export default __exports__